import React from 'react';
import HeaderPart from './headerPart';
// import PropTypes from 'prop-types'
import {observer} from 'mobx-react';
import {TStore} from 'tplus-poslogin';

@observer
class Head extends React.Component{
    constructor(props,context){
        super(props,context)

    }
    // static contextTypes = {
    //     viewModel: PropTypes.object,
    //     onEvent:PropTypes.func,
    //     onAction:PropTypes.func,
    //     stores:PropTypes.object,
    // }
    render(){
        const store = TStore.restore();
        return <HeaderPart name={store.storeName}/>
    }
}
export default Head
